import type { SxProps, Theme } from '@mui/material';

export const suggestedQuestionsContainerSx: SxProps<Theme> = {
  py: 0.75,
  px: 1,
  gap: 0.5,
};

export const suggestedQuestionSkeletonSx: SxProps<Theme> = {
  borderRadius: '999px',
  bgcolor: (theme) => theme.palette.custom.OV.sys.surfaceContainer,
};

export const suggestedQuestionButtonSx: SxProps<Theme> = (theme) => ({
  justifyContent: 'flex-start',
  width: '100%',
  minWidth: 0,
  textAlign: 'left',
  textTransform: 'none',
  whiteSpace: 'normal',
  lineHeight: 1.3,
  fontSize: '0.71875rem',
  fontWeight: 400,
  color: theme.palette.custom.OV.sys.onSurface,
  background: theme.palette.custom.OV.sys.surfaceContainer,
  border: `1px solid ${theme.palette.custom.OV.sys.outlineVariant}`,
  borderRadius: '999px',
  py: 0.75,
  px: 1.25,
  '&:hover': {
    background: theme.palette.custom.OV.sys.surfaceContainerHighest,
    color: theme.palette.custom.OV.sys.onBackground,
    borderColor: theme.palette.custom.OV.sys.outlineVariant,
  },
});
